// Single source of truth for EMANAC copy and contact details.
// Edit here and every page picks it up.

export const ORG = {
  name: "EMANAC",
  expansion: "Empowering Minds for Advancing Next-Gen Computing",
  motto: "Transforming Minds, Shaping the Future",
  email: "emanac.org@gmail.com",
  phone: "(+233) 55-286-6593",
  phoneHref: "tel:+233552866593",
  address: "Kasoa, CX-013-7847",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export const SOCIALS = [
  { label: "LinkedIn", href: "https://www.linkedin.com/company/emanac/" },
  { label: "X", href: "https://x.com/emanac_org" },
  { label: "Instagram", href: "https://www.instagram.com/emanacorg/" },
  { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61569829539952" },
  { label: "YouTube", href: "https://youtube.com/@emanac_org" },
];

export const VISION =
  "To build a dynamic and inclusive community that equips young individuals with essential IT skills, unlocking their potential in the ever-evolving digital world.";

export const MISSION =
  "To empower young people by introducing them to the transformative world of IT through hands-on learning and mentorship.";

export const ABOUT_LEAD =
  "We aim to bridge the gap in IT literacy, empowering the youth to become active contributors to the global tech space.";

export const ABOUT_BODY = [
  "By fostering collaboration among tech enthusiasts, we aspire to create a hub for innovation and shared growth. Our community will serve as a beacon of opportunity, inspiring others to pursue technology-driven solutions. Together, we envision a future where IT literacy is no longer a barrier but a bridge to success.",
  "We are dedicated to reducing IT illiteracy in underserved communities by providing accessible and affordable training programs. By fostering a collaborative network, we encourage innovation, knowledge sharing, and teamwork among tech enthusiasts.",
];

export const PILLARS = [
  {
    icon: "learn",
    title: "Accessible Training",
    body: "Affordable, hands-on IT training programs that bring underserved communities into the digital world.",
  },
  {
    icon: "community",
    title: "Collaborative Community",
    body: "A network of tech enthusiasts sharing knowledge, building together and mentoring the next generation.",
  },
  {
    icon: "code",
    title: "Software Solutions",
    body: "Our team designs and delivers software engineering solutions for organisations and businesses.",
  },
];

export const COMMITMENTS = [
  {
    title: "Accessible & affordable",
    body: "Training programs priced and placed so that cost and location are never the barrier.",
  },
  {
    title: "Knowledge sharing",
    body: "A collaborative network that encourages innovation, teamwork and learning from one another.",
  },
  {
    title: "Industry-ready skills",
    body: "Equipping individuals to excel in technology, entrepreneurship and data-driven industries.",
  },
  {
    title: "Continuous learning",
    body: "A culture of adaptability that keeps our members at the forefront of technological advancement.",
  },
];

export const PROGRAMS = [
  { title: "IT Fundamentals", body: "Computer literacy, the internet, productivity tools and staying safe online." },
  { title: "Programming & Web", body: "Problem solving, programming foundations and building for the web." },
  { title: "Data Skills", body: "Working with data — spreadsheets, analysis and data-driven decision making." },
  { title: "Tech Entrepreneurship", body: "Turning ideas into products, and products into sustainable ventures." },
  { title: "Mentorship", body: "Guidance from practitioners who have walked the path before you." },
];

export const SOLUTIONS = [
  { title: "Websites & Web Apps", body: "Fast, accessible sites and web applications built to grow with you." },
  { title: "Mobile Apps", body: "Cross-platform apps that put your service in your users' pockets." },
  { title: "Data & Dashboards", body: "Pipelines, reporting and dashboards that turn records into decisions." },
  { title: "Cloud & Automation", body: "Hosting, integrations and automated workflows that save real hours." },
  { title: "Tech Consulting", body: "Honest advice on what to build, what to buy and how to get there." },
];

export const PROCESS = [
  { title: "Discover", body: "We learn your goals, users and constraints." },
  { title: "Design", body: "We shape the solution and agree on scope." },
  { title: "Build", body: "We ship in small, visible increments." },
  { title: "Support", body: "We launch, hand over and stay on call." },
];
